<template>
  <div class="container">
    <!-- 左侧 -->
    <sz-mode szType="grid" :bg="'left_bg'" position="left-top" width="23.5%" height="28%" lineShow="true">
      <template #grid>
        <div class="panel_item">
          <div class="panel_title">党建总览</div>
          <div v-if="slideList.length > 0">
            <swiper :options="swiperOptions">
              <swiper-slide v-for="(item, index) in slideList" :key="index">
                <img :src="baseURL + item.historyImg" alt="" />
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
              <!-- <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div> -->
            </swiper>
          </div>
        </div>
      </template>
    </sz-mode>
    <sz-mode szType="grid" :bg="'left_bg'" position="left-bottom" width="23.5%" height="68%" lineShow="true">
      <template #grid>
        <div class="panel_item">
          <div class="panel_title">党建专栏</div>
          <div class="his_list">
            <div class="his_list_item" v-for="(item, index) in djHis" @click.stop="seeHis(index)">
              <div class="list_item_title">{{ item.historyName }}</div>
              <div class="list_item_date">{{ item.historyDate }}</div>
            </div>
          </div>
        </div>
      </template>
    </sz-mode>
    <!-- 右侧 -->
    <sz-mode szType="grid" :bg="'left_bg'" position="right-top" width="23.5%" height="28%" lineShow="true">
      <template #grid>
        <div class="panel_item">
          <div class="panel_title">党员基本情况</div>
          <!-- member总人数 -->
          <div class="flex_center_align flex_item">
            <div class="flex_colum flex_item_col">
               <span class="flex_item_num">{{ totalNums.formalMember }}人</span>
<!--              <span class="flex_item_num">1005人</span>-->
              <span>正式党员</span>
            </div>
            <div class="flex_colum flex_item_col">
               <span class="flex_item_num">{{ totalNums.prepareMember }}人</span>
<!--              <span class="flex_item_num">54人</span>-->
              <span>预备党员</span>
            </div>
            <div class="flex_colum flex_item_col">
               <span class="flex_item_num">{{ totalNums.developMember }}人</span>
<!--              <span class="flex_item_num">60人</span>-->
              <span>发展党员</span>
            </div>
          </div>
          <div class="flex_center_align flex_item">
            <div class="flex_colum flex_item_col">
               <span class="flex_item_num">{{ totalNums.flowMember }}人</span>
<!--              <span class="flex_item_num">112人</span>-->
              <span>流动党员</span>
            </div>
            <div class="flex_colum flex_item_col">
               <span class="flex_item_num">{{ totalNums.bedMember }}人</span>
<!--              <span class="flex_item_num">210人</span>-->
              <span>基层党组织</span>
            </div>
            <div class="flex_colum flex_item_col">
               <span class="flex_item_num">{{ totalNums.armyMember }}人</span>
<!--              <span class="flex_item_num">52人</span>-->
              <span>军队退役党员</span>
            </div>
          </div>
        </div>
      </template>
    </sz-mode>

    <sz-mode szType="grid" :bg="'left_bg'" position="right-bottom" width="23.5%" height="68%" lineShow="true">
      <template #grid>
        <div class="panel_item">
          <div class="panel_title">党员基本情况</div>
          <div class="chart_title">近三年党费统计走势图</div>
          <div id="dfChart" ref="dfChart" style="width:100%;height:200px;margin-top:20px"></div>
          <div class="flex_center_align flex_space">
            <div class="chart_item">
              <div class="chart_title">学历结构</div>
              <div id="xlChart" ref="xlChart" style="width:100%;height:150px;margin-top:20px"></div>
            </div>
            <!-- <div class="chart_item">
              <div class="chart_title">行业结构</div>
              <div id="hyChart" ref="hyChart" style="width:100%;height:150px;margin-top:20px"></div>
            </div> -->
          </div>
          <div class="flex_center_align flex_space">
            <div class="chart_item">
              <div class="chart_title">党龄结构</div>
              <div id="dlChart" ref="dlChart" style="width:100%;height:150px;margin-top:20px"></div>
            </div>
            <!-- <div class="chart_item">
              <div class="chart_title">年龄结构</div>
              <div id="nlChart" ref="nlChart" style="width:100%;height:150px;margin-top:20px"></div>
            </div> -->
          </div>
        </div>
      </template>
    </sz-mode>

    <!-- 党建专栏详情 -->
    <wg-mode ref="wgMode"></wg-mode>
    <cun-mode ref="cunMode"></cun-mode>
    <!-- 地图 -->
    <div id="mapcontainer" class="divwxMap" style="width: 100%; height:100%"></div>

    <!-- <t-footer :></t-footer> -->
    <t-footer :tabList="list" @tab="handlerTab"></t-footer>

  </div>
</template>
<script>
import * as echarts from 'echarts'
import WgMode from '@/components/wgMode.vue'
import { pieoption, poption, lineOption } from '@/utils/options'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getHisItems, getDangIndex, getDangArea, getDangBatch } from '@/api/api.js'
import 'swiper/css/swiper.min.css'
import CunMode from '@/components/cunMode.vue'
import tFooter from '@/components/footer.vue'

export default {
  components: {
    WgMode,
    swiper,
    swiperSlide,
    CunMode,
    tFooter
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_API,
      baseForm: {},
      totalNums: {},
      djHis: [{ historyName: 'dangjian党建' }],
      swiperOptions: {
        autoplay: false,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets'
        }
      },
      // slideList: [{ img: 'https://img1.baidu.com/it/u=4049022245,514596079&fm=253&app=120&size=w931&n=0&f=JPEG&fmt=auto?sec=1681318800&t=2b375ed6d93d638d1be405d04eb8c7f2' }]
      slideList: [],
      lineData: { xAxisData: [], yAxisData: [] },
      list: [{ tabName: '联合党委', value: 'joint', id: '', active: false, icon:''  }]
      // require('@/assets/img/tb1.png')

    }
  },
  mounted() {
    this.baseForm = JSON.parse(sessionStorage.getItem('userInfo'))
    this.$nextTick(() => {
      this.initMap()
      // 查询党建专栏列表
      this.getItems()
      this.searchDetails()
      this.getAreas()
      this.drowLine()
    })
  },
  methods: {
    handlerTab(val){
      console.log(val);
      this.$router.push({
        name:'jointParty',
      })
    },
    getAreas() {
      getDangArea({ villageId: this.baseForm.regionId }).then(res => {
        if (res.code == '0') {
          if (res.model.length > 0) {
            res.model.map(i => {
              i.articleContent = i.branchText
              i.name = i.branchName
              i.type = 'party'
            })
          }
          this.setCunMap(res.model)
        }
      })
    },
    searchDetails() {
      getDangIndex({ villageId: this.baseForm.regionId }).then(res => {
        if (res.code == 0) {
          this.totalNums = res.model.memberCount
          this.$nextTick(() => {
            this.drowFunction(res.model)
          })
        }
      })
    },
    //查询党建列表
    getItems() {
      getHisItems({ villageId: this.baseForm.regionId, historyType: 1, page: 1, rows: 10000 }).then(res => {
        if (res.code == '0') {
          if (res.items.length > 0) {
            let arr = []
            res.items.map(item => {
              if (item?.historyImg) arr.push(item)
              if (item.historyDate) item.historyDate = this.$moment(item.historyDate).format('YYYY-MM-DD')
            })
            this.slideList = arr
          }
          if (this.slideList.length > 1) {
            this.swiperOptions.autoplay = {
              delay: 3000,
              disableOnInteraction: true
            }
          }
          this.djHis = res.items
        }
      })
    },
    //初始化地图
    initMap() {
      // vue项目需要先声明 T = window.T，不然后面无法获取到。
      let T = window.T
      this.wxMap = null
      let initMap = new T.Map('mapcontainer') // div的id
      // 传参中心点经纬度，以及放大程度，最小1，最大18
      initMap.centerAndZoom(new T.LngLat(Number(this.baseForm.longitude), Number(this.baseForm.latitude)), 12)
      initMap.setStyle('black')
      initMap.enableDrag()
      initMap.enableScrollWheelZoom()
      this.wxMap = initMap
      //
    },
    //在地图标点
    setCunMap(data) {
      this.setMapSetting(data)
      this.setRegion(data)
    },
    //查看党建信息详情
    seeHis(index) {
      let data = this.djHis[index]
      data.itemtype = 'history'
      this.$refs.wgMode.initData(data)
    },
    drowLine() {
      getDangBatch({ villageId: this.baseForm.regionId, branchId: '' }).then(res => {
        if (res.model.length) {
          let narr = []
          let varr = []
          res.model.forEach(i => {
            narr.push(i.name)
            varr.push(i.value)
          })
          //y轴的范围去近最小值的被100整除数，这样折线图的趋势幅度会变大
          let min = Math.min(...varr);
          let mins = (Math.ceil(min/100)-1) * 100; // 将num除以10并向上取整，再乘以10
          lineOption.yAxis[0].min = mins;
          console.log(Math.ceil(min/100))
          // this.$nextTick(() => {
          lineOption.xAxis[0].data = narr
          // lineOption.yAxis.data = varr
          lineOption.series[0].data = varr
          var edom1 = echarts.init(this.$refs.dfChart, null, { renderer: 'svg' })
          edom1.clear()
          edom1.setOption(lineOption)
          // })
        }
      })
    },

    drowFunction(data) {
      pieoption.tooltip = {
        show: true,
        formatter: '{b}: {c}人'
      }
      pieoption.series[0].label = { show: false }
      pieoption.series[0].emphasis = { show: true }

      pieoption.legend = {
        itemHeight: 10,
        itemWidth: 12,
        orient: '',
        show: true,
        top: '5%',
        right: '10%',
        textStyle: { color: '#fff' }
      }
      if (data?.background) {
        pieoption.series[0].radius = ['45%', '75%']
        pieoption.series[0].center = ['40%', '50%']
        pieoption.series[0].data = data.background

        var piedom = echarts.init(this.$refs.xlChart, null, { renderer: 'svg' })
        piedom.clear()
        piedom.setOption(pieoption)
      }
      this.$nextTick(() => {
        if (data.branchAge.length > 0) {
          pieoption.series[0].radius = ['0', '75%']
          pieoption.series[0].center = ['40%', '50%']
          pieoption.series[0].data = data.branchAge
          var piedom1 = echarts.init(this.$refs.dlChart, null, { renderer: 'svg' })
          piedom1.clear()
          piedom1.setOption(pieoption)
        }
      })
    }
  }
}
</script>
<style lang="scss" scope>
.container {
  z-index: 9;
}
.container {
  .divwxMap {
    z-index: 0;
  }
  .c_left {
    position: fixed;
    left: 40px;
    width: 23.5%;
  }
  .c_right {
    position: fixed;
    right: 40px;
    width: 23.5%;
  }
  .panel_item {
    margin: 5px 12px;
    .panel_title {
      font-family: 'Microsoft YaHei';
      font-style: normal;
      font-weight: 400;
      font-size: 26px;
      text-shadow: 0px 0px 4px rgba(255, 255, 255, 0.25);
    }
    .chart_item {
      flex: 1;
    }
    .chart_title {
      margin: 10px;
    }
    .center_title {
      text-align: center;
    }
  }
  .flex_item {
    width: 100%;
    justify-content: space-evenly;
    text-align: center;
    flex-wrap: wrap;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #fff;
    .flex_item_col {
      width: 30%;
      margin: 10px 0;
      flex: 1;
      color: #fff;
    }
    .flex_item_num {
      font-family: 'Microsoft YaHei';
      font-style: normal;
      font-weight: 400;
      font-size: 26px;
    }
  }
  .member {
    height: 105px;
    overflow-y: auto;
  }
  .member_mes {
    width: 100%;
    justify-content: space-evenly !important;
    margin: 2px 0;
    cursor: pointer;
  }
  /*网格员姓名 */
  .grid_member .member_mes .member_full_name {
    font-family: 'Source Han Sans CN';
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    /* color: #FFFFFF; */
  }

  /*网格员电话 */
  .grid_member .member_mes .member_mobile {
    font-family: 'Source Han Sans CN';
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    /* color: #FFFFFF; */
  }
  .his_list_item {
    padding: 10px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.4);
    cursor: pointer;
  }
  .list_item_title {
    width: 100%;
    font-size: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
  .list_item_date {
    font-size: 16px;
    text-align: right;
    color: #ccc;
  }
  .swiper-container {
    width: 400px;
    height: 190px;
    .swiper-slide {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
